// extracted by mini-css-extract-plugin
export var accordion = "faq-module--accordion--iBVNX";
export var custom = "faq-module--custom--GgBB8";
export var description = "faq-module--description--nwBjy";
export var heading = "faq-module--heading--OioEf";